import {
    IDotRezPartialBookingSessionData
} from "../../../../dot-rez-api/data-contracts/booking/dot-rez-booking-session-data.interface";
import {SellJourneyBundleMutation} from "./sell-journey-bundle.mutation";


export class SellReturnJourneyBundleMutation extends SellJourneyBundleMutation {

    async _runMutation(): Promise<IDotRezPartialBookingSessionData> {

        if (!this.booking.returnJourney) {
            throw new Error('You must first sell return journey before selling a bundle for it');
        }

        let sellBundleForOneJourneyRequest = this._createJourneySellBundleRequest(this.booking.returnJourney, []);

        await this.session.sellBundle({
            ssrKeysToRemove: sellBundleForOneJourneyRequest.ssrKeysToRemove.distinct(key => key),
            journeys: sellBundleForOneJourneyRequest.requests //TODO check for child bundle
        });

        const bookingState = await this.session.bookingStateQueryBuilder().useBookingData().getBookingState();

        let ssrUpgradesPairs = this.booking.departureJourney?.selectedBundle?.getCurrentSsrsUpgradesPairs() ?? [];
        if(ssrUpgradesPairs.length === 0) {
            return bookingState;
        }

        this.booking.updateBookingSessionData(bookingState);
        sellBundleForOneJourneyRequest = this._createJourneySellBundleRequest(this.booking.returnJourney, ssrUpgradesPairs);
        await this.session.sellBundle({
            ssrKeysToRemove: sellBundleForOneJourneyRequest.ssrKeysToRemove.distinct(key => key),
            journeys: sellBundleForOneJourneyRequest.requests //TODO check for child bundle
        });

        return await this.session.bookingStateQueryBuilder().useBookingData().getBookingState();
    }

    async onAfterBookingSessionDataUpdated(): Promise<void> {
        await super.onAfterBookingSessionDataUpdated();
        this.services.analytics.flightSelectionEvents.logAddToCartForReturn(this.booking);
    }
}
